import React from 'react'
import { ReactComponent } from './CircleProfileIcon.svg'
import { MergeReactElementProps } from '../../types'

interface CircleProfileIconProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', CircleProfileIconProps>

export const CircleProfileIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#9a9a9a' } = props
    return <ReactComponent stroke={color} ref={ref} {...props} />
  }
)
